var map = {
	"./IDP.ts": 97434,
	"./LMS.ts": 88077,
	"./adaptation.ts": 49800,
	"./articles.ts": 82214,
	"./chat.ts": 82947,
	"./groups.ts": 30933,
	"./polls.ts": 27327,
	"./services.ts": 20469,
	"./single_pages.ts": 59318,
	"./task_tracker.ts": 84259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91639;